import * as React from "react";
import Expand from "../../common/expander/Expand";
import AddFilterButton from "../button/AddFilterButton";
import FilterWrapper from "../filterWrapper/FilterWrapper";
import Filter from "../../../../model/workspace/Filter";
import {none} from "ts-option";
import "./filterContainer.scss";
import {ViewColumn} from "../../../../model/workspace/ViewColumn";
import SaveFiltersButton from "../button/SaveFiltersButton";
import {SaveFiltersConfig} from "../button/SaveFiltersButtonConfigView";
import {WorkspaceName} from "../../table/workspace/WorkspaceContainer";

const uuidv4 = require("uuid/v4");

interface IProps {
	columns: ViewColumn[];
	filters: Filter[];
	onSaveView?: (config: SaveFiltersConfig) => void;
	onFiltersChange: (filters: Filter[], refreshData: boolean) => void;
	isExpanded: boolean;
	workspaceName: WorkspaceName
}

export default class FiltersContainer extends React.Component<IProps, {}> {
	render() {
		return (
			<Expand isOpen={this.props.isExpanded}>
				<div className={"c-filter-container"}>
					<AddFilterButton
						onSelect={(f) => this.props.onFiltersChange(this.props.filters.concat(f), false)}
						filters={this.props.columns.filter(c => c.columnDefinition.filterable).map(
							c => new Filter(uuidv4(), c.columnDefinition, null, none))}/>
					{this.props.filters.map(
						(f, index) =>
							<FilterWrapper
								key={index}
								filter={f}
								onRemove={(refreshData) => {
									const filters = this.props.filters;
									filters.splice(index, 1);
									this.props.onFiltersChange(filters, refreshData);
								}}
								onChange={(changedFilter: Filter) => this.props.onFiltersChange(
									this.props.filters.map(f => f.id == changedFilter.id ? changedFilter : f), true)}
								workspaceName={this.props.workspaceName}/>)}
					{this.props.onSaveView && this.props.filters.some(f => f.type !== null) &&
					<SaveFiltersButton onSave={this.props.onSaveView}/>}
				</div>
			</Expand>
		)
	}
}